import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/EditFormModal";
import AccountExerciseForm from "./AccountExerciseForm";
const EditCharacterOfPain = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Edit_Account_Modal, initialValues, Loader } = faqProps;
  const [form] = Form.useForm();

  return (
    <div>
      <FormModal
        modalTitle="Edit Exercise"
        submitButtonText="Update"
        cancelButtonText="Cancel"
        editApiRequest="EditRecord"
        apiLoader="StartSpinner"
        editApiMethod="PUT"
        editApiName="editAccountExercise"
        ModalName="Edit_Account_Modal"
        confirmLoading={Loader}
        ModalType="Hide_Modal"
        visible={Edit_Account_Modal ? Edit_Account_Modal : false}
        initialValues={initialValues}
        width={550}
        form={form}
        recordName="accountExList"
      >
        <AccountExerciseForm />
      </FormModal>
    </div>
  );
};

export default EditCharacterOfPain;
